import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useLeaveType } from "../../hooks/useLeaveType";
import LeaveTypeModule from "../../components/modules/LeaveType/LeaveTypeModule";
import { useEnumsApi } from "../../hooks/useEnumsApi";

const LeaveTypePage = ({ user, userAccess, isHideSideMenu }) => {
  // We initialize the hook ONCE here
  const leaveMethods = useLeaveType();
  const { taxTreatmentsEnum, loading: enumsLoading } = useEnumsApi();


  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Leave Types"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Leave Types</h3>
            </div>

            {/* Pass all hook data and methods to the module */}
            <LeaveTypeModule
              user={user}
              {...leaveMethods}
              taxTreatmentsEnum={taxTreatmentsEnum}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={leaveMethods.showMessage}
        message={leaveMethods.message}
        isSuccess={leaveMethods.isSuccess}
      />

      <LoadingSpinner loading={leaveMethods.loading || enumsLoading} />
    </>
  );
};

export default LeaveTypePage;